<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                           {{$t('reset_password')}}
                        </div>
                        <ValidationObserver v-slot="{ passes }">
                            <form @submit.prevent="passes(onSubmit)">

                                <base-input class="input-group-alternative"
                                            :name="$t('password')"
                                            placeholder="Password"
                                            required
                                            rules="required|min:6"
                                            type="password"
                                            v-model="form.password">
                                </base-input>

                                <div class="text-center">
                                    <base-button nativeType="submit" type="primary" class="my-4">{{$t('reset_password')}}</base-button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <router-link :to="'/'+$i18n.locale+'/login'" class="text-light">
                            <small>{{$t('login')}}</small>
                        </router-link>
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="'/'+$i18n.locale+'/register'" class="text-light"><small>{{$t('create_account')}}</small></router-link>
                    </div>
                </div>
            </div>
            <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal>

            <modal :show.sync="modal_success">

            <p>{{$t('success_reset')}}</p>

            <template slot="footer">
                <base-button @click="modal_success = false, goLogin()" type="primary">{{$t('login')}}</base-button>
            </template>

            </modal>

        </div>
</template>
<script>
import { ValidationObserver } from "vee-validate"
import i18n from "@/i18n"
  export default {
    name: 'reset',
    components: {
        ValidationObserver
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_success: false,
        reset_key: this.$route.query.code,
        email: this.$route.query.email,
        form: {
          password: ''
        }
      }
    },
    created () {
        this.checkCurrentLogin()
    },
    updated () {
        this.checkCurrentLogin()
    },
    methods: {
        checkCurrentLogin () {
            if (this.$store.state.token) {
                this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
            }
        },
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        onSubmit () {
            this.$http.post('auth/resetPassword', {
                "email": this.email,
                "reset_key": this.reset_key,
                "password": this.form.password
            })
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.modal_success = true
        },
        onSubmitFailed (req) {
            this.modalAlert(req)
        },
        goLogin () {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/login')
        }
    }
  }
</script>
<style>
</style>
